import { render, staticRenderFns } from "./DispatchDetail.vue?vue&type=template&id=48fd4c50&"
import script from "./DispatchDetail.vue?vue&type=script&lang=js&"
export * from "./DispatchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports